import React from 'react';
import { useSelector } from 'react-redux';
import { Carousel, HeaderCarouselDefault, useCarousel } from '@yme/atoms/carousel';
import { GridWrapper } from '@yme/atoms/grid';
import { IndentWrapper } from '@yme/components/Separator';
import { useWindowSize } from '@yme/hooks/useWindowSize';
import { DestinationCard } from '@yme/molecules/cards';
import { getRTL } from '@yme/selectors/index';
import { useTranslation } from '@yme/services/i18n';
import { GAP_BETWEEN_ITEMS_DESKTOP, GAP_BETWEEN_ITEMS_MOBILE, CAROUSEL_CONFIG } from './constants';
import { useRelatedExperiences } from './hooks';
export const ExperienceRelatedExperiences = ({ isRemoveBottomIndent, title, edpURL, }) => {
    const { t } = useTranslation();
    const { isInfiniteDesktopView, isMobileView } = useWindowSize();
    const destinations = useRelatedExperiences(edpURL);
    const isRightToLeft = useSelector(getRTL);
    const { activeItem, onClickPrevItem, onClickNextItem, indexOfCount, counts, setCounts } = useCarousel();
    const commonCarouselProps = {
        titleCarousel: title ?? t('destinations_experienceRelatedExperiences_title'),
        isRightToLeft,
        activeItem,
        onClickPrevItem,
        onClickNextItem,
        indexOfCount,
        counts,
    };
    const arrowTitles = {
        titlePrev: t('common_previous_label'),
        titleNext: t('common_next_label'),
    };
    if (!destinations.length)
        return null;
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent, isRightToLeft: isRightToLeft },
        React.createElement(GridWrapper, null,
            React.createElement(HeaderCarouselDefault, { ...commonCarouselProps, arrowTitles: arrowTitles, isArrowNavigationVisible: true, isArrowNavigationVisibleOnTablet: true }),
            React.createElement(Carousel, { ...commonCarouselProps, carouselConfig: CAROUSEL_CONFIG, getterSize: isMobileView ? GAP_BETWEEN_ITEMS_MOBILE : GAP_BETWEEN_ITEMS_DESKTOP, items: destinations, isDotsPanelVisible: !isInfiniteDesktopView, ChildComponent: DestinationCard, setCounts: setCounts }))));
};
ExperienceRelatedExperiences.displayName = 'ExperienceRelatedExperiences_AEMComponent';
